import { useEffect, useState } from 'react';

import { useGetTreatment, useSplitContext } from '@zg-rentals/split';

import SplitTestConstants from '../constants/SplitTestConstants';

const useAccessActivateOnReview = () => {
  const {
    split: { experiments: splitExperiments },
  } = useSplitContext();

  const [canAccessActivateOnReview, setCanAccessActivateOnReview] = useState<boolean | null>(null);

  const {
    data: getTreatmentData,
    isFetching: isGetTreatmentFetching,
    isLoading: isGetTreatmentLoading,
    refetch: refetchGetTreatment,
  } = useGetTreatment(
    {
      featureName: SplitTestConstants.ZRM_ACTIVATE_ON_REVIEW,
    },
    {
      enabled: false,
      refetchOnMount: false,
    },
  );

  useEffect(() => {
    if (!getTreatmentData && !isGetTreatmentFetching) {
      refetchGetTreatment();
    }
  }, []);

  // splitExperiments needs to have the experiment name as a property to check the treatment value
  const splitExperimentsHasOwnProperty = splitExperiments.hasOwnProperty(SplitTestConstants.ZRM_ACTIVATE_ON_REVIEW);

  useEffect(() => {
    if (isGetTreatmentLoading === false && splitExperimentsHasOwnProperty && canAccessActivateOnReview === null) {
      setCanAccessActivateOnReview(getTreatmentData?.treatment === 'on');
    }
  }, [isGetTreatmentLoading, splitExperimentsHasOwnProperty]);

  return {
    canAccessActivateOnReview,
    isActivateOnReviewLoading: canAccessActivateOnReview === null,
  };
};

export default useAccessActivateOnReview;
